/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Опрос с решением пользователя.
 */
export interface PollWithUserDecisionView { 
    /**
     * Название.
     */
    titleText?: string;
    /**
     * Описание.
     */
    descriptionText?: string;
    /**
     * Ссылка на анкету.
     */
    pollLink?: string;
    /**
     * Дата начала опроса.
     */
    dateStart?: string;
    /**
     * Дата окончания опроса.
     */
    dateEnd?: string;
    /**
     * Время прохождения опроса.
     */
    pollDuration?: number;
    /**
     * Создал мероприятие.
     */
    createdBy?: string;
    /**
     * Идентификатор ассоциации.
     */
    organisationId?: string;
    /**
     * Идентификатор комитета.
     */
    committeeId?: string;
    /**
     * текст завершающей речи после прохождения опроса.
     */
    completionText?: string;
    /**
     * опция пошагового прохождения опроса.
     */
    displayStepByStep?: boolean;
    /**
     * ограничение на прохождение опроса в минутах.
     */
    timeLimit?: number;
    /**
     * регистрировать время прохождения опроса.
     */
    registerTime?: boolean;
    /**
     * признак что опрос является шаблоном.
     */
    isTemplate?: boolean;
    /**
     * ID использованного шаблона.
     */
    templateId?: string;
    /**
     * Идентификатор опроса.
     */
    id?: string;
    /**
     * Статус
     */
    status?: number;
    /**
     * Идентификатор решения.
     */
    decisionTypeCode?: number;
    /**
     * Решение.
     */
    decisionTypeName?: string;
    /**
     * ID фотографии.
     */
    photoId?: string;
    /**
     * Временная зона создателя опроса в формате +ЧЧММ, например, \"+0500\"
     */
    localTimezone?: string;
}

